import cx from 'classnames';
import {useContext} from 'react';

import {Icon} from 'components';
import {UserSessionContext} from 'context';

import {AgentChatbotSidebar} from './AgentChatbotSidebar';
import {AvatarHistorySidebar} from './AvatarHistorySidebar';
import {NotesSidebar} from './NotesSidebar';
import {ParticipantsSidebar} from './ParticipantsSidebar';
import {PreSessionFlowSidebar} from './PreSessionFlowSidebar';
import {ScreenshotsSidebar} from './ScreenshotsSidebar';
import {SipHistorySidebar} from './SipHistorySidebar';
import {TextChatHistorySidebar} from './TextChatHistorySidebar';
import {TextChatSidebar} from './TextChatSidebar';
import {TranscriptionsSidebar} from './TranscriptionsSidebar';
import {VirtualBackgroundSidebar} from './VirtualBackgroundSidebar';

export const InSessionSidebar: React.FC = () => {
    const {sidebarView, onSidebarViewChange} = useContext(UserSessionContext);

    return (
        <div className={cx('tw-bg-light tw-h-full tw-relative md:tw-w-80 -md:tw-absolute -md:tw-w-full', {'tw-hidden': !sidebarView})}>
            <div className='tw-absolute tw-top-3 tw-right-3'>
                <Icon
                    name='close'
                    size='lg'
                    button
                    onClick={() => onSidebarViewChange(null)}
                />
            </div>
            <ParticipantsSidebar />
            <ScreenshotsSidebar />
            <TextChatSidebar />
            <TextChatHistorySidebar />
            <AvatarHistorySidebar />
            <NotesSidebar />
            <SipHistorySidebar />
            <VirtualBackgroundSidebar />
            <TranscriptionsSidebar />
            <PreSessionFlowSidebar />
            <AgentChatbotSidebar />
        </div>
    );
};
